import axios from 'axios'
import { setMetaData } from '../../bankrate-tracking/metadata'

const defaultAttrPid = 'direct'
const attrCookieGeneratorEndpoint = process.env.ATTR_URL

const brCookieData = {
  pid: null,
  brmp: null,
  queryStringPid: null
}

window.cohesion('ready', function() {
  handleImpressionCookie().then(() => {
    // Emit the pid loaded event with the new pid which GA / GTM listens for
    setPid(getPid())
  })
})

function getWebContext() {
  let wc = {}
  if (window._Tagular && window._Tagular.webContext) {
    wc = window._Tagular.webContext
  }
  return wc
}

// Handle the Impression Cookies (brmp / attr)
async function handleImpressionCookie() {
  // Start by loading the existing cookies into our CookieDataObject
  brCookieData.brmp = getImpressionCookie('brmp')

  // Query param Pid overrides all others
  brCookieData.queryStringPid = getQueryStringPID()

  // Attribution will set both attr and brmp cookie
  await fetchBrmpCookie()
}

// Retrieve one of the impression cookies by name
function getImpressionCookie(name) {
  let cookie = getCookie(name)
  if (cookie) {
    try {
      return JSON.parse(decodeURIComponent(cookie))
    } catch (e) {
      console.log(e) // eslint-disable-line
    }
  }
  return null
}

// Retrieve the attr cookie from the attribution-service
// This cookie is being set via JSON in the response body
function fetchBrmpCookie() {
  let { sessionId, anonymousId, instanceId } = getWebContext()
  if (!sessionId) {
    sessionId = getCookie('tglr_sess_id') || ''
  }
  if (!anonymousId) {
    anonymousId = getCookie('tglr_anon_id') || ''
  }
  if (!instanceId) {
    anonymousId = ''
  }

  const hasQueryString = window.location.href.indexOf('?') > 5
  let requestParameters = {
    referrerUrl: document.referrer,
    url: `${window.location.href}${
      hasQueryString ? '&' : '?'
    }session_id=${sessionId}&anonymous_id=${anonymousId}&instance_id=${instanceId}`
  }

  // Query Param Pid > Current attr Pid
  if (requestParameters.pid == null) {
    requestParameters.pid =
      brCookieData.brmp && brCookieData.brmp.attr_pid
        ? brCookieData.brmp.attr_pid
        : ''
  }

  axios
    .post(attrCookieGeneratorEndpoint, requestParameters, {
      withCredentials: true
    })
    .then(response => {
      // Set json attr cookie in the local cookie store
      brCookieData.brmp =
        response.data && response.data.cookie
          ? response.data.cookie
          : brCookieData.brmp
    })
    .catch(err => {
      console.log(err)
    })
}

// The pid value in the query parameters overrides other sources
function getQueryStringPID() {
  let qspid
  let params = getQueryParameters()
  if (params.pid) {
    qspid = params.pid
  }

  return qspid
}

// Retrieves the current default pid being used by other services
function getPid() {
  return brCookieData.brmp && brCookieData.brmp.attr_pid
    ? brCookieData.brmp.attr_pid
    : defaultAttrPid
}

// Updates the Pid in the meta data and emits the pid via the 'pid.loaded' event
function setPid(pid) {
  if (typeof pid !== 'undefined') {
    brCookieData.pid = pid
    setMetaData('Site', pid)
  }
}

// Utility Functions //

// Inspect and separate the given cookie from the document
function getCookie(name) {
  let value = '; ' + document.cookie
  let parts = value.split('; ' + name + '=')
  if (parts.length === 2) {
    return parts
      .pop()
      .split(';')
      .shift()
  }
}

// Break down the current query parameters
function getQueryParameters(str) {
  return (str || document.location.search)
    .replace(/(^\?)/, '')
    .split('&')
    .map(
      function(n) {
        return (n = n.split('=')), (this[n[0]] = n[1]), this
      }.bind({})
    )[0]
}
